import React, { useState, useEffect, useContext } from 'react'
import {
  CButton,
  CFormCheck,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CTable,
  CFormSwitch,
  CTableHead,
  CTableRow,
  CTableBody,
  CTableDataCell,
} from '@coreui/react'
import { GlobalContext } from 'src/views/context/GlobalState'
import { getThumbnail } from 'src/views/utils/helper'
import ReactDragListView from 'react-drag-listview/lib/index.js'
import { isEmpty } from 'lodash'
import PlusIcon from '../../../assets/plus-icon.svg'
import EditIcon from '../../../assets/edit-icon.svg'
import TrashIcon from '../../../assets/trash-icon.svg'
import SixDots from '../../../assets/six-dots.svg'
import CopyLight from '../../../assets/copy-light.svg'
import AdSectionHolder from '../../../assets/ad-section-holder.svg'
import CarouselSectionHolder from '../../../assets/carousel-section-holder.png'
import DeleteModal from 'src/components/DeleteModal/DeleteModal'
import CustomDescriptionBox from 'src/components/CustomDescriptionBox'
import useAxios from 'axios-hooks'
import { SYSTEM_METADATA_API } from 'src/views/utils/urls'
import { AppContext } from 'src/views/context/app'
import TemplateAccordion from '../templateAccordion'
import Loading from 'react-fullscreen-loading'
import AttachLink from '../attachLink'
import ImageUploader from 'src/components/ImageUploader/ImageUploader'
import AdNCarouselCardModal from './adNCarouselCardModal'

const AdNCarouselModal = ({ componentData, modifyData, modalSpecificData, onCancel }) => {
  // const [alignment, setAlignment] = useState('')
  const { loader, setLoader } = useContext(AppContext)

  const { userSessionObj } = useContext(GlobalContext)

  const [isRightAligned, setIsRightAligned] = useState(false)

  const [autoSlide, setAutoSlide] = useState()
  const [title, setTitle] = useState('')
  const [slidesData, setSlidesData] = useState([])
  const [restricted, setRestricted] = useState(false)

  const [errorData, setErrorData] = useState({})
  const [imageData, setImageData] = useState([])
  const [adTitle, setAdTitle] = useState('')
  const [imageS3key, setImageS3key] = useState('')
  const [link, setLink] = useState({
    type: '',
    data: {},
  })
  const [ctaButton, setCtaButton] = useState({
    enabled: true,
    text: '',
    position: 'CENTER',
  })

  const [cardModal, setCardModal] = useState(false)
  const [deleteModal, setDeleteModal] = useState(false)
  const [selectedCardIndex, setSelectedCardIndex] = useState('')
  const [slideObj, setSlideObj] = useState({})

  const clearError = (type) => {
    let temp = errorData
    temp[`${type}`] = ''
    setErrorData({ ...temp })
  }

  const [{ data: categoryList, loading: categoryListLoading }] = useAxios({
    url: SYSTEM_METADATA_API,
    method: 'get',
  })

  useEffect(() => {
    setLoader(categoryListLoading)
  }, [categoryListLoading])

  useEffect(() => {
    if (!isEmpty(componentData?.data?.carousel_section?.slide_data)) {
      setSlidesData(componentData?.data?.carousel_section?.slide_data)
      setAutoSlide(componentData?.data?.carousel_section?.auto_slide)
      setTitle(componentData?.data?.carousel_section?.heading)
    }

    const imgData = [
      {
        title: '',
        id: 'mdImg',
        width: 657,
        height: 375,
        divwidth: '11rem',
        divheight: '6.28rem',
        assetId: '',
        titleDisabled: true,
        setAssetId: (id) => {},
        setImage: (obj) => {
          clearError('imageS3key')
          setImageS3key(obj?.s3Key)
        },
        onRemoveImg: () => {
          setImageS3key('')
        },
        imageUrl: '',
        imagePaddingX: '6px',
        imagePaddingY: '6px',
        uploadIconflexRow: true,
        uploadIconsize: '12px',
        btnMarginTop: '8px',
      },
    ]

    let tempdata = componentData.data

    setAdTitle(tempdata?.ad_section?.heading)
    setCtaButton(tempdata?.ad_section?.cta_button)
    setLink(tempdata?.ad_section?.link)
    setImageS3key(tempdata?.ad_section?.image_s3key)
    setIsRightAligned(tempdata?.is_right_aligned)

    imgData[0]['assetId'] = tempdata.ad_section.image_s3key
    imgData[0]['imageUrl'] = getThumbnail(
      userSessionObj?.session_data?.cf_domain_name,
      tempdata.ad_section.image_s3key,
    )

    setImageData(imgData)
  }, [])

  const copyCard = (idx) => {
    let tempslidesDataArr = slidesData
    let copyObj = slidesData[idx]
    tempslidesDataArr.splice(idx + 1, 0, copyObj)
    setSlidesData([...tempslidesDataArr])
  }

  const deleteCard = (index, slidesLength) => {
    if (slidesLength === 3) {
      setRestricted(true)
    } else {
      setRestricted(false)
      setSelectedCardIndex(index)
      setDeleteModal(true)
    }
  }

  const onPositionChange = (event) => {
    let { value, checked } = event.target
    if (checked) {
      setCtaButton((prevBtn) => ({ ...prevBtn, position: value }))
    }
  }

  const onDeleteCard = (index) => {
    setSlidesData((prevData) => prevData.filter((data, idx) => idx !== index))
    setDeleteModal(false)
    setSelectedCardIndex('')
  }

  const validateInfo = () => {
    let isFormValid = true
    let temp = {}

    if (imageS3key.trim().length === 0) {
      isFormValid = false
      temp.imageS3key = 'Upload Image!'
    }

    setErrorData({ ...temp })
    return isFormValid
  }

  const handleSave = () => {
    if (!validateInfo()) return

    let elementObj = {
      is_right_aligned: isRightAligned,
      carousel_section: {
        auto_slide: autoSlide,
        heading: title,
        slide_data: slidesData,
      },
      ad_section: {
        heading: adTitle,
        image_s3key: imageS3key,
        cta_button: ctaButton,
        link: link,
      },
    }

    modifyData(componentData.id, elementObj)
  }

  const dragProps = {
    onDragEnd(fromIndex, toIndex) {
      const data = [...slidesData]
      const item = data.splice(fromIndex, 1)[0]
      data.splice(toIndex, 0, item)
      setSlidesData([...data])
    },
    handleSelector: '',
  }

  /* Add card code */
  const addNewCard = () => {
    setCardModal(true)
  }

  const editCard = (index) => {
    setSlideObj(slidesData[index])
    setSelectedCardIndex(index)
    setCardModal(true)
  }
  const addCallback = (data) => {
    let tempArr = [...slidesData]
    tempArr.push(data)
    setSlidesData(tempArr)
  }
  const updateCallback = (data) => {
    let tempArr = [...slidesData]
    tempArr[selectedCardIndex] = data
    setSlidesData(tempArr)
  }

  const handleCtaToggle = (event) => {
    let { checked } = event.target
    setCtaButton((prevState) => {
      return {
        ...prevState,
        enabled: checked,
      }
    })
  }

  const onAlignmentChange = (event, str) => {
    // console.log(event.target === true, str)
    if (str !== undefined) {
      setIsRightAligned(str === 'LEFT' ? true : false)
      return
    }
    const { value } = event.target
    setIsRightAligned(value === 'LEFT' ? true : false)
  }

  let accordionItems = [
    {
      title: 'Edit Carousal Elements',
      description: 'Specify the images, headers, paragraphs of the carousal Cards.',
      children: (
        <div
          style={{ backgroundColor: '#e5e5e5' }}
          className=" px-4 py-3 d-flex flex-column justify-content-center align-items-center"
        >
          <div className="w-100 px-1">
            <h6 style={{ fontSize: '14px' }}>HEADING</h6>
            <CustomDescriptionBox
              limit={30}
              rows={1}
              value={title}
              onChange={(value) => setTitle(value)}
              style={{ fontSize: '12px' }}
              limitFontSize={'11px'}
              useFormInput={true}
            />
          </div>
          <div
            style={{ fontSize: '1rem' }}
            className="d-flex justify-content-between w-100 px-1 -mb-2"
          >
            <h6 style={{ fontSize: '14px' }}>
              SLIDES <br />
              <span className="font-thin text-xs">Drag to Re-arrange</span>
            </h6>
            <div className="d-flex align-items-end">
              <span style={{ fontSize: '13px' }} className="mr-2 mb-1">
                Auto Slide
              </span>
              <CFormSwitch
                label=""
                value={autoSlide}
                checked={autoSlide}
                valid={autoSlide}
                id="buttonEnable"
                onChange={(e) => setAutoSlide(e.target.checked)}
              />
            </div>
          </div>

          <div
            className="d-flex justify-content-center h-full flex-shrink-0"
            style={{ width: '100%', minHeight: '100%' }}
          >
            <div
              style={{
                width: '100%',
                height: '100%',
                overflowX: 'visible',
                overflowY: 'auto',
              }}
              className="flex flex-column justify-content-start align-items-center rounded-md scrollbar px-1"
            >
              <ReactDragListView {...dragProps}>
                <CTable
                  className="mt-1 w-full"
                  style={{
                    borderCollapse: 'separate',
                    borderSpacing: '0 13px',
                    overflow: 'visible',
                  }}
                >
                  <CTableBody>
                    {!isEmpty(slidesData) ? (
                      slidesData.map((item, index) => (
                        <CTableRow
                          key={index}
                          className="bg-[#fff] rounded outline outline-1 outline-gray-400 hover:outline-[#2172eb] hover:outline-2"
                          style={{
                            borderRadius: '10px',
                            cursor: 'all-scroll',
                          }}
                        >
                          <CTableDataCell
                            style={{ width: '4%' }}
                            align="middle"
                            className="hover:cursor-move"
                          >
                            <img src={SixDots} alt="" />
                          </CTableDataCell>
                          <CTableDataCell style={{ width: '15%', height: '100%' }} align="middle">
                            <img
                              src={getThumbnail(
                                userSessionObj?.session_data?.cf_domain_name,
                                item.image_s3key,
                              )}
                              alt=""
                              className="w-100 h-100"
                              // style={{ height: '56px', width: '107px' }}
                            />
                          </CTableDataCell>
                          <CTableDataCell style={{ width: 'auto' }} align="middle">
                            <div className="-mt-1 -mb-5" style={{ lineHeight: '13px' }}>
                              <p
                                className="font-medium line-clamp-1"
                                style={{ fontSize: '13px', lineHeight: '13px' }}
                              >
                                {item.heading}
                              </p>
                              <p
                                className="line-clamp-1"
                                style={{ fontSize: '11px', lineHeight: '14px' }}
                              >
                                {item.description}
                              </p>
                            </div>
                          </CTableDataCell>
                          <CTableDataCell
                            align="middle"
                            style={{ textAlign: 'center', width: '5%' }}
                          >
                            <div
                              className=" h-[32px] w-[32px] rounded-full bg-[#2172eb] flex justify-center items-center cursor-pointer shadow-2xl"
                              onClick={() => editCard(index)}
                              style={{ boxShadow: '2px 2px 4px 0 rgba(0, 0, 0, 0.3)' }}
                            >
                              <img src={EditIcon} className="w-[17px] h-[17px] " alt="editicon" />
                            </div>
                          </CTableDataCell>
                          <CTableDataCell
                            align="middle"
                            style={{ textAlign: 'center', width: '5%' }}
                          >
                            <div
                              className=" h-[32px] w-[32px] rounded-full bg-[#2172eb] flex justify-center items-center cursor-pointer shadow-2xl"
                              onClick={() => copyCard(index)}
                              style={{ boxShadow: '2px 2px 4px 0 rgba(0, 0, 0, 0.3)' }}
                            >
                              <img src={CopyLight} className="w-[17px] h-[17px] " alt="copyIcon" />
                            </div>
                          </CTableDataCell>
                          <CTableDataCell
                            align="middle"
                            style={{ textAlign: 'center', width: '5%' }}
                          >
                            <div
                              className="mr-4 h-[32px] w-[32px] rounded-full bg-[#2172eb] flex justify-center items-center cursor-pointer shadow-2xl"
                              onClick={() => deleteCard(index, slidesData.length)}
                              style={{ boxShadow: '2px 2px 4px 0 rgba(0, 0, 0, 0.3)' }}
                            >
                              <img src={TrashIcon} className="w-[17px] h-[17px]" alt="trashicon" />
                            </div>
                          </CTableDataCell>
                        </CTableRow>
                      ))
                    ) : (
                      <CTableRow>
                        <CTableDataCell colSpan="6">
                          <p>No Data Found</p>
                        </CTableDataCell>
                      </CTableRow>
                    )}
                  </CTableBody>
                </CTable>
              </ReactDragListView>
              <div
                className="overflow-hidden bg-[#fff] rounded outline outline-1 outline-gray-400 w-full flex flex-col justify-center items-center cursor-pointer flex-shrink-0 p-3 -mt-2 mb-2"
                style={{
                  borderRadius: '10px',
                }}
                onClick={() => addNewCard()}
              >
                <div
                  className="h-[24px] w-[24px] rounded-full bg-[#2172eb] flex justify-center items-center shadow"
                  style={{ boxShadow: '2px 2px 4px 0 rgba(0, 0, 0, 0.3)' }}
                >
                  <img src={PlusIcon} className="w-[15px] h-[15px]" alt="trashicon" />
                </div>
                <span className="text-sm font-medium mt-2 ">Add a new Slide</span>
              </div>
              {deleteModal && (
                <DeleteModal
                  openModal={deleteModal}
                  title={`Are you sure you want to delete this Slide ?`}
                  confirmButtonText={`Yes`}
                  onCancel={() => {
                    setSelectedCardIndex('')
                    setDeleteModal(false)
                  }}
                  onConfirm={() => onDeleteCard(selectedCardIndex)}
                />
              )}
            </div>
          </div>
          <div className="message-text error-message">{/* <p>{errorData.imageS3key}</p> */}</div>
        </div>
      ),
      itemStyle: 'mt-4',
    },
    {
      title: 'Edit Ad Section',
      description: 'Specify the image, button and link of the Ad/Promotional section.',
      children: (
        <div
          style={{ backgroundColor: '#e5e5e5' }}
          className=" px-4 py-3 d-flex flex-column justify-content-center align-items-center"
        >
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <div style={{ width: '50%', paddingRight: '3%', borderRight: '1px solid #707070' }}>
              <div className="px-1">
                <h6 style={{ fontSize: '13px' }}>Section Title</h6>
                <CustomDescriptionBox
                  limit={25}
                  rows={1}
                  value={adTitle}
                  onChange={(value) => setAdTitle(value)}
                  style={{ fontSize: '12px', borderRadius: '0' }}
                  limitFontSize={'11px'}
                  useFormInput={true}
                />
              </div>
              <div className="px-1 d-inline-block">
                <h6 style={{ fontSize: '13px' }}>Add Image</h6>
                <span style={{ fontSize: '11px', color: '#707070', display: 'block' }}>
                  Specify the promotional image which you would like to display in the Ad section.
                </span>
                <div className="d-inline-block">
                  <ImageUploader data={imageData} />
                  <span
                    className="mt-1"
                    style={{
                      fontSize: '11px',
                      color: '#707070',
                      textAlign: 'center',
                      width: '100%',
                      display: 'inline-block',
                    }}
                  >
                    657px X 375px
                  </span>
                  <div className="message-text error-message text-center">
                    <p>{errorData.imageS3key}&#10240;</p>
                  </div>
                </div>
              </div>
            </div>
            <div style={{ width: '47%' }}>
              <div className="d-flex justify-content-between">
                <h6
                  style={{ fontSize: '13px', color: `${!ctaButton.enabled ? '#918b8b' : 'black'}` }}
                >
                  Button Text
                </h6>
                <div className="flex">
                  <span style={{ fontSize: '12px', fontWeight: '600' }} className="mx-2">
                    Add CTA Button
                  </span>
                  <CFormSwitch
                    label=""
                    id="buttonEnable"
                    checked={ctaButton.enabled}
                    valid={ctaButton.enabled}
                    onChange={(e) => handleCtaToggle(e)}
                  />
                </div>
              </div>
              <CustomDescriptionBox
                limit={15}
                rows={1}
                value={ctaButton.text}
                onChange={(value) => setCtaButton((prev) => ({ ...prev, text: value }))}
                style={{ fontSize: '12px', borderRadius: '0' }}
                limitFontSize={'11px'}
                useFormInput={true}
                disabled={!ctaButton.enabled}
              />

              <div className="w-100 px-1">
                <h6 style={{ fontSize: '13px', marginBlockEnd: '0' }}>Set Button Position</h6>
                <span style={{ fontSize: '11px', color: '#707070' }}>
                  Specify the position of the button within the Ad section.
                </span>
                <div className="mt-1">
                  <CTable
                    style={{
                      fontSize: '12px',
                      width: '284px',
                      marginBottom: 0,
                      textAlign: 'center',
                    }}
                    className="py-2"
                    // striped
                    bordered
                    borderColor="white"
                  >
                    <CTableHead>
                      <CTableRow>
                        <CTableDataCell
                          style={{ backgroundColor: '#ccc', width: '28%', padding: '4px' }}
                        ></CTableDataCell>
                        <CTableDataCell
                          style={{ backgroundColor: '#ccc', width: '24%', padding: '4px' }}
                        >
                          Left
                        </CTableDataCell>
                        <CTableDataCell
                          style={{ backgroundColor: '#ccc', width: '24%', padding: '4px' }}
                        >
                          Center
                        </CTableDataCell>
                        <CTableDataCell
                          style={{ backgroundColor: '#ccc', width: '24%', padding: '4px' }}
                        >
                          Right
                        </CTableDataCell>
                      </CTableRow>
                    </CTableHead>
                    <CTableBody className="">
                      <CTableRow>
                        <CTableDataCell
                          style={{ backgroundColor: '#ccc', padding: '4px' }}
                          align="middle"
                        >
                          Top
                        </CTableDataCell>
                        <CTableDataCell
                          style={{ backgroundColor: '#fff', padding: '4px' }}
                          align="middle"
                        >
                          <CFormCheck
                            onChange={(e) => onPositionChange(e)}
                            inline
                            type="radio"
                            id="TOP_LEFT"
                            value="TOP_LEFT"
                            label=""
                            checked={ctaButton.position === 'TOP_LEFT'}
                          />
                        </CTableDataCell>
                        <CTableDataCell
                          style={{ backgroundColor: '#fff', padding: '4px' }}
                          align="middle"
                        >
                          <CFormCheck
                            onChange={(e) => onPositionChange(e)}
                            inline
                            type="radio"
                            id="TOP_CENTER"
                            value="TOP_CENTER"
                            label=""
                            checked={ctaButton.position === 'TOP_CENTER'}
                          />
                        </CTableDataCell>
                        <CTableDataCell
                          style={{ backgroundColor: '#fff', padding: '4px' }}
                          align="middle"
                        >
                          <CFormCheck
                            onChange={(e) => onPositionChange(e)}
                            inline
                            type="radio"
                            id="TOP_RIGHT"
                            value="TOP_RIGHT"
                            label=""
                            checked={ctaButton.position === 'TOP_RIGHT'}
                          />
                        </CTableDataCell>
                      </CTableRow>
                      <CTableRow>
                        <CTableDataCell
                          style={{ backgroundColor: '#ccc', padding: '4px' }}
                          align="middle"
                        >
                          Center
                        </CTableDataCell>
                        <CTableDataCell
                          style={{ backgroundColor: '#ebebeb', padding: '4px' }}
                          align="middle"
                        >
                          <CFormCheck
                            onChange={(e) => onPositionChange(e)}
                            inline
                            type="radio"
                            id="CENTER_LEFT"
                            value="CENTER_LEFT"
                            label=""
                            checked={ctaButton.position === 'CENTER_LEFT'}
                          />
                        </CTableDataCell>
                        <CTableDataCell
                          style={{ backgroundColor: '#ebebeb', padding: '4px' }}
                          align="middle"
                        >
                          <CFormCheck
                            onChange={(e) => onPositionChange(e)}
                            inline
                            type="radio"
                            id="CENTER"
                            value="CENTER"
                            label=""
                            checked={ctaButton.position === 'CENTER'}
                          />
                        </CTableDataCell>
                        <CTableDataCell
                          style={{ backgroundColor: '#ebebeb', padding: '4px' }}
                          align="middle"
                        >
                          <CFormCheck
                            onChange={(e) => onPositionChange(e)}
                            inline
                            type="radio"
                            id="CENTER_RIGHT"
                            value="CENTER_RIGHT"
                            label=""
                            checked={ctaButton.position === 'CENTER_RIGHT'}
                          />
                        </CTableDataCell>
                      </CTableRow>
                      <CTableRow>
                        <CTableDataCell
                          style={{ backgroundColor: '#ccc', padding: '4px' }}
                          align="middle"
                        >
                          Bottom
                        </CTableDataCell>
                        <CTableDataCell
                          style={{ backgroundColor: '#fff', padding: '4px' }}
                          align="middle"
                        >
                          <CFormCheck
                            onChange={(e) => onPositionChange(e)}
                            inline
                            type="radio"
                            id="BOTTOM_LEFT"
                            value="BOTTOM_LEFT"
                            label=""
                            checked={ctaButton.position === 'BOTTOM_LEFT'}
                          />
                        </CTableDataCell>
                        <CTableDataCell
                          style={{ backgroundColor: '#fff', padding: '4px' }}
                          align="middle"
                        >
                          <CFormCheck
                            onChange={(e) => onPositionChange(e)}
                            inline
                            type="radio"
                            id="BOTTOM_CENTER"
                            value="BOTTOM_CENTER"
                            label=""
                            checked={ctaButton.position === 'BOTTOM_CENTER'}
                          />
                        </CTableDataCell>
                        <CTableDataCell
                          style={{ backgroundColor: '#fff', padding: '4px' }}
                          align="middle"
                        >
                          <CFormCheck
                            onChange={(e) => onPositionChange(e)}
                            inline
                            type="radio"
                            id="BOTTOM_RIGHT"
                            value="BOTTOM_RIGHT"
                            label=""
                            checked={ctaButton.position === 'BOTTOM_RIGHT'}
                          />
                        </CTableDataCell>
                      </CTableRow>
                    </CTableBody>
                  </CTable>
                </div>
              </div>
            </div>
          </div>
          <div className="w-100 mt-4 mb-4">
            <AttachLink
              linkData={link}
              id={'text1'}
              selectorWidth={'80%'}
              categoryData={
                categoryList
                  ? categoryList?.data.filter(
                      (info, idx) => info.type === 'category' && info.status,
                    )
                  : []
              }
              setLinkData={(value) => {
                clearError('ctaButtonLink')
                setLink(value)
              }}
            />
          </div>
        </div>
      ),
      itemStyle: 'mt-4',
    },
  ]

  return (
    <>
      {cardModal && (
        <AdNCarouselCardModal
          cancelCardModal={() => {
            setSelectedCardIndex('')
            setSlideObj({})
            setCardModal(false)
          }}
          slideObj={slideObj}
          addCallback={addCallback}
          updateCallback={updateCallback}
          isEdit={!isEmpty(slideObj)}
          categoryList={categoryList ? categoryList?.data : []}
        />
      )}
      <CModal scrollable size="lg" className="" visible={true} style={{ minHeight: '80vh' }}>
        <Loading loading={loader} background={'rgba(60, 60, 60, 0.6)'} loaderColor="#efefef" />
        <CModalHeader
          style={{ borderBottom: 0, paddingBottom: 0 }}
          className="d-flex justify-content-center align-items-center"
        >
          <p style={{ fontSize: '20px' }}>
            <b style={{ fontWeight: '500' }}>Mini Carousel with Ad Section</b>
          </p>
        </CModalHeader>
        <CModalBody
          style={{ minHeight: '72vh' }}
          className="px-5 static-scrollbar-class border d-flex flex-column justify-content-between align-items-around"
        >
          <div>
            <div className="mt-1">
              <h6 style={{ fontSize: '13px' }} className="">
                Select the Section Style <span style={{ color: 'red' }}>*</span>
              </h6>
              <div className="mt-1 flex justify-content-between">
                <div className="d-flex flex-column justify-content-center ">
                  <CFormCheck
                    type="radio"
                    id="leftcard"
                    label="Left side Carousal with Right side Ad"
                    value="LEFT"
                    className="recent-stories-radio font-semibold"
                    checked={isRightAligned}
                    onChange={(e) => onAlignmentChange(e)}
                  />
                  <div
                    style={{
                      border: `1.5px solid ${isRightAligned === true ? '#2172eb' : '#707070'}  `,
                    }}
                    className="flex justify-content-between align-items-start px-2 py-2"
                    onClick={(e) => onAlignmentChange(e, 'LEFT')}
                  >
                    <div className=" mr-1">
                      {/* <img src={ParaIcon} alt="para img" /> */}
                      <h6 style={{ fontSize: '13px' }}>Card Carousel</h6>
                      <img src={CarouselSectionHolder} alt="" className="mr-1" />
                      <img src={CarouselSectionHolder} alt="" className="mr-1" />
                      <img src={CarouselSectionHolder} alt="" className="mr-1" />
                    </div>
                    <div>
                      <h6 style={{ fontSize: '13px' }}>Ad Segment</h6>
                      <img src={AdSectionHolder} alt="" />
                    </div>
                  </div>
                </div>

                <div className="d-flex flex-column justify-content-center ">
                  <CFormCheck
                    type="radio"
                    id="rightcard"
                    label="Left side Ad with Right side Carousel"
                    value="RIGHT"
                    className="recent-stories-radio font-semibold"
                    checked={!isRightAligned}
                    onChange={(e) => onAlignmentChange(e)}
                  />
                  <div
                    style={{
                      border: `1.5px solid ${isRightAligned === false ? '#2172eb' : '#707070'}  `,
                    }}
                    className="flex justify-content-between align-items-start px-2 py-2"
                    onClick={(e) => onAlignmentChange(e, 'RIGHT')}
                  >
                    <div>
                      <h6 style={{ fontSize: '13px' }}>Ad Segment</h6>
                      <img src={AdSectionHolder} alt="" />
                    </div>
                    <div className="ml-1">
                      {/* <img src={ParaIcon} alt="para img" /> */}
                      <h6 style={{ fontSize: '13px' }}>Card Carousel</h6>
                      <img src={CarouselSectionHolder} alt="" className="ml-1" />
                      <img src={CarouselSectionHolder} alt="" className="ml-1" />
                      <img src={CarouselSectionHolder} alt="" className="ml-1" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <TemplateAccordion items={accordionItems} styles={''} />
          </div>
          <div className="mt-2">
            <span style={{ fontSize: '12px', color: restricted === true ? 'red' : 'inherit' }}>
              * Minimum number of cards in Carousel Section is Three.
            </span>
            <span className="" style={{ fontSize: '12px', display: 'block' }}>
              ** Leave a section blank to remove it from the component. Do not fill any details.
            </span>
          </div>
        </CModalBody>
        <CModalFooter style={{ borderTop: 0 }} className="px-5">
          <div className="pb-3">
            <CButton
              style={{ color: 'black', border: '1px solid black', fontSize: '1.1rem' }}
              className="mx-4 bg-white rounded-1 btn-focus-none"
              onClick={onCancel}
            >
              Cancel
            </CButton>
            <CButton
              style={{ fontSize: '1.1rem' }}
              className=" bg-black rounded-1 btn-focus-none px-3"
              onClick={handleSave}
            >
              Save
            </CButton>
          </div>
        </CModalFooter>
      </CModal>
    </>
  )
}

export default AdNCarouselModal
